import { render, staticRenderFns } from "./RankingRegentes.vue?vue&type=template&id=03ab4ed3&"
import script from "./RankingRegentes.vue?vue&type=script&lang=js&"
export * from "./RankingRegentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports